import React from 'react';
import ReactSelect from 'react-select';
import { systemText } from '../../../helpers/string';
import FormLabelv2 from '../formLabelv2';

const Selectv2 = props => {
	const {
		dataBlockValue,
		dataSetValue,
		label,
		help,
		infoHelp,
		placeholder,
		error,
		warning,
		id,
		data,
		allowMultiple,
		mandatory,
		isLoading,
		isTree,
		readonly,
		filters,
		inline,
	} = props;

	const [value, setValue] = React.useState(props.value);
	const [options, setOptions] = React.useState([]);

	React.useEffect(() => {
		setOptions(data.map(d => ({ value: d.id, label: d.name })));
	}, [data]);

	React.useEffect(() => {
		const temp = allowMultiple
			? options.filter(x => props?.value?.some(v => v === x.value))
			: options.find(x => x.value === props?.value);

		setValue(temp);
	}, [props?.value, options]);

	const updateValue = newValue => {
		if (allowMultiple) {
			props.onChange(newValue.map(x => x.value));
		} else {
			props.onChange(newValue?.value);
		}

		setValue(newValue);
	};

	const styles = {
		container: base => ({
			...base,
		}),
		control: base => ({
			...base,
			borderColor: error ? '#e56682' : warning ? '#e8b066' : base.borderColor,
			boxShadow: error ? '0 0 0 1px #e56682' : warning ? '#e8b066' : 'none',
			'&:hover': {
				borderColor: error ? '#e56682' : warning ? '#e8b066' : base.borderColor,
			},

			flexWrap: 'nowrap', // keep arrows on the same line
			minHeight: 40,
			alignItems: 'flex-center', // so top padding is respected when wrapping
			padding: 0,
			margin: 0,
		}),
		valueContainer: base => ({
			...base,
			display: 'flex',
			flexWrap: 'wrap', // allow chips to wrap
			flex: '1 1 auto',
			alignItems: 'center',
			padding: 5,
			margin: 0,
		}),
		indicatorsContainer: base => ({
			...base,
			flexShrink: 0, // keep arrows from shrinking / wrapping
			alignSelf: 'center', // center them within the padded control
			margin: '0 3px 3px 0',
		}),
		input: base => ({
			...base,
			display: 'none',
		}),
		multiValueRemove: (base, state) => {
			return state.data.isFixed || readonly || (value?.length === 1 && mandatory)
				? { ...base, display: 'none' }
				: base;
		},
	};

	const ctrl = (
		<ReactSelect
			{...props}
			value={value}
			styles={styles}
			isMulti={allowMultiple}
			name={id}
			options={options}
			onChange={option => updateValue(option)}
			isClearable={!readonly}
			isSearchable={!readonly}
			menuIsOpen={readonly ? false : undefined}
			isLoading={isLoading}
			placeholder={placeholder || systemText('General/Controls/Select/Filter')}
		/>
	);

	return inline ? ctrl : <FormLabelv2 {...props}>{ctrl}</FormLabelv2>;
};

export default Selectv2;
